module.exports = __webpack_public_path__ + "static/media/codePieChart.450a9f65.jpg";